import { MediaTracksMixin } from "./mixin.js";
MediaTracksMixin(globalThis.HTMLMediaElement);
